module.exports = __webpack_public_path__ + "img/silversea.fa219ac0.jpg";